import { routes as coreRoutes } from 'Core/routes';
import { routes as easyCreditRoutes } from 'Modules/easyCredit/routes';
import { routes as checkoutRoutes } from 'Modules/checkout/routes';

export const routes = {
  us: [...checkoutRoutes, ...coreRoutes, ...easyCreditRoutes],
  de: [...checkoutRoutes, ...coreRoutes, ...easyCreditRoutes],
};
